// extracted by mini-css-extract-plugin
module.exports = {"grid":"login_grid__254Yt","column":"login_column__3Gd0A","form":"login_form__xTzg8","button":"login_button__2kzSg","widgetLogin":"login_widgetLogin__34CFQ"};